
import Form from 'react-bootstrap/Form'
import {Col, Row} from "react-bootstrap";
import PropTypes from "prop-types";
import Container from "react-bootstrap/Container";

function InvoiceChecks(props) {
    const handleChange = (e, index) => {
        // Create a new array and a new object for the specific index to avoid mutation
        const newCheckedList = props.status.map((item, i) => {
            if (i === index) {
                return {
                    ...item,
                    status: e.target.checked,
                    user: props.user,
                    date: new Date().toLocaleDateString()
                };
            }
            return item;
        });
        props.setStatus(newCheckedList);
    }
    const disableCheck = (index) => {
        switch (index) {
            case 0: return ((!props.level.approve()) || props.status[1].status)
            case 1: return  ((!props.level.ready() ) || !props.status[0].status || props.status[2].status);
            case 2: return  ((!props.level.invoicing()) || !props.status[0].status || !props.status[1].status || props.status[3].status);
            // Fixed Case 3: ensure it follows the logical flow of the workflow
            case 3: return  ((!props.level.delivery()) || !props.status[2].status);
            default:
                return true;
        }
    }
    return (
        <>
            <Container style={{'fontSize': '0.7vw', width: "65%"}}>
                <Row>
                    {props.status.map((item, index) => (
                        <Col key={index} style={{
                            textAlign: "center",
                            boxShadow: "inset 0.1em 0.1em 0.1em 0 rgba(255,255,255,0.5), inset -0.1em -0.1em 0.1em 0 rgba(0,0,0,0.5)",
                            backgroundColor: "rgba(255,255,255,0.5)",
                            borderRadius: "10px",
                            padding: "10px",
                            margin: "10px",

                        }}>
                            <Form.Control style={{textAlign: "center"}} plaintext readOnly value={item.name || ""} />
                            <Form.Control style={{textAlign: "center"}} plaintext readOnly value={item.user || ""}/>
                            <Form.Check style={{textAlign: "center"}} inline type="checkbox" checked={item.status }
                                        onChange={(e) => {
                                            handleChange(e, index)
                                        }} disabled={disableCheck(index) || props.isPosted }

                            >
                            </Form.Check>
                            <Form.Control style={{
                                textAlign: "center"
                            }} plaintext readOnly value={item.date?item.date:""}/>
                        </Col>
                    ))}
                </Row>
            </Container>

        </>
    )
}

InvoiceChecks.propTypes = {
    isPosted: PropTypes.bool.isRequired,
    level: PropTypes.object.isRequired,
    user: PropTypes.string.isRequired,
    status: PropTypes.array.isRequired,
    setStatus: PropTypes.func.isRequired,
}
InvoiceChecks.defaultProps = {
    isPosted: false,
    user: "",
    status: [
        { name: "Approval", status: false, user: "", date: "" },
        { name: "Ready", status: false, user: "", date: "" },
        { name: "Invoiced", status: false, user: "", date: "" },
        { name: "Delivered", status: false, user: "", date: "" }
    ],
}
export default InvoiceChecks